import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgDemonstration(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 -4 18 24" {...props}>
      <path
        d="M17.692 11.445l.14.003c1.058.065 1.853 1.17 1.853 2.404v1.082c0 .589-.41 1.066-.916 1.066H4.96c-.505 0-.915-.477-.915-1.066v-1.127c0-1.102.64-2.111 1.57-2.318 1.25-.28 2.344.828 2.344 2.234 0-1.258.877-2.278 1.958-2.278 1.05 0 1.9.964 1.947 2.172.05-1.208.899-2.172 1.949-2.172 1.081 0 1.957 1.02 1.957 2.278 0-1.298.934-2.344 2.062-2.275zM9.917 7.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm3.896 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm3.914 0a1.5 1.5 0 11.001 3 1.5 1.5 0 010-3zm-11.725 0a1.5 1.5 0 11.001 3 1.5 1.5 0 010-3zm5.045-6.08l3.78.752-.359 2.44-1.577-.316-.166 1.877a5.398 5.398 0 00-.73.658l.237-2.666-1.543-.306.358-2.44zM7.701 0l.715 3.034-2.09.667.73 2.586a5.001 5.001 0 00-.856-.54l-.519-1.84-1.966.627L3 1.5zm8.836 1.289L21 1.724 19.628 5.06l-.01-.011-.43 1.118a4.949 4.949 0 00-.583-.39l.515-1.337-2.583-3.15z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Demonstration')(SvgDemonstration);
